<template>
  <section>
    <v-app-bar elevation="4" class="app-bar-style">
      <template v-slot:prepend>
        <img
          :src="require(`@/assets/header/logo.png`)"
          @click="routeToLink('home')"
          alt="Logo"
          class="logo-image"
        />
        <v-divider
          v-if="screenName === 'complySync'"
          vertical
          class="border-opacity-50 ml-5 mt-2"
          length="47px"
          color="#8f8f8f"
        ></v-divider>
        <img
          v-if="screenName === 'complySync'"
          :src="require(`@/assets/solutions/comply-sync/ComplySyncATO logo.png`)"
          @click="routeToLink('home')"
          alt="Logo"
          class="sub-logo-image"
        />
      </template>
      <template v-slot:append>
        <div class="menu-section">
          <div class="d-flex">
            <h3
              v-for="item in menuItems"
              :key="item.key"
              class="mr-6 ml-6 menu-items"
              :class="activeMenu ? (item.label === activeMenu.label ? 'menu-item-hover' : '') : ''"
              @mouseover="showMenu(item)"
              @mouseleave="scheduleHideMenu"
              @click="menuClick(item)"
            >
              {{ item.label }}
            </h3>
          </div>
        </div>
        <div class="menu-section-hamburger">
          <v-app-bar-nav-icon
            @click="hambergerMenu()"
            :icon="(hamMenu || hamSubMenu) ? 'mdi-window-close' : 'mdi-menu'"
          ></v-app-bar-nav-icon>
        </div>
      </template>
    </v-app-bar>

    <v-menu
      v-model="hamMenu"
      class="ham-menu-style"
    >
      <v-card class="ham-menu-card-style">
        <v-card-actions>
          <v-row v-if="menuItems">
            <v-col
              :cols="12"
              :xs="12"
              :sm="12"
              v-for="item in menuItems"
              :key="item"
              class="ham-menu-items"
              @click="item.categories.length > 0 ? hamMenuItemClick(item) : (item.link ? menuClick(item) : '')"
            >
              <a class="ham-menu-links">{{ item.label }}</a>
              <v-icon
                v-if="item.categories.length > 0"
                icon="mdi-chevron-right"
                color="#969696"
              ></v-icon>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-menu>

    <v-menu
      v-model="hamSubMenu"
      class="ham-submenu-style"
    >
      <v-card class="ham-submenu-card-style">
        <div @click="subMenuBack()" class="back-icon"></div>
        <v-card-actions>
          <v-row v-if="activeMenu && activeMenu.categories">
            <v-col
              :cols="12"
              :xs="12"
              :sm="12"
              v-for="item in activeMenu.categories"
              :key="item"
              class="ham-submenu-items"
            >
              <a
                @click="item.link !== '' ? routeToLink(item.link) : ''"
                class="ham-submenu-links"
              >
                {{ item.category }}
              </a>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-menu>

    <v-menu
      v-if="activeMenu !== null ? activeMenu.categories.length > 0 : false"
      v-model="menu"
      class="mymenu"
      :class="activeMenu.label === 'CAPABILITIES' ? 'capability-menu' : (activeMenu.label === 'SOLUTIONS' ? 'solutions-menu' : 'sectors-menu')"
      @mouseover="clearHideMenuTimeout"
      @mouseleave="scheduleHideMenu"
      transition="slide-y-transition"
    >
      <v-card class="card-style">
        <v-card-actions class="card-style-action">
          <div
            v-for="item in activeMenu !== null ? activeMenu.categories : []"
            :key="item"
            style="text-align: left"
            class="card-menu-item"
            @click="item.link !== '' ? routeToLink(item.link) : ''"
          >
            <a
              class="drop-down-links"
            >
              {{ item.category }}
            </a>
          </div>
        </v-card-actions>
      </v-card>
    </v-menu>
  </section>
</template>

<script lang="ts" setup>
  import { ref } from "vue";
  import router  from "@/router";
  import { defineProps } from 'vue';
  import { onMounted, onUnmounted, watch } from 'vue';

  const props = defineProps<{
    screenName: string;
  }>();

  let menuItems: any = [
    {
      key: "1",
      label: "CAPABILITIES",
      categories: [
        {link:'application-modernization', category: "Application Modernization"},
        {link:'business-intelligence', category: "Business Intelligence"},
        {link:'cloud', category: "Cloud"},
        {link:'cyber-security', category: "Cyber Security"},
        {link:'devsecops', category: "DevSecOps"},
        {link:'digital-services', category: "Digital Services"},
        {link:'health-it-services', category: "Health IT Services"},
        {link:'national-security-services', category: "National Security Services"},
        {link:'program-management', category: "Program Management and Strategy"},
      ],
    },
    {
      key: "2",
      label: "SOLUTIONS",
      categories: [
        {link:'complySync-ato', category: "ComplySync ATO"},
        {link:'debt-management', category: "Debt Management"},
        {link:'security-data-lake', category: "Security Data Lake"},
        {link:'test-automation-platform', category: "Test Automation Platform"},
        {link:'hephaestus', category: "Hephaestus"}
      ],
    },
    {
      key: "3",
      label: "SECTORS",
      categories: [
        {link:'banking-and-finance', category: "Banking and Finance"},
        {link:'federal-civilian', category: "Federal Civilian"},
        {link:'health-care', category: "Healthcare"},
        {link:'national-security', category: "National Security"},
        {link:'reg-tech', category: "RegTech"},
        {link:'state-and-local-government', category: "State and Local Goverment"},
      ],
    },
    {
      key: "4",
      label: "CONTRACT VEHICLES",
      categories: [],
      link: "contract-vehicles"
    },
    {
      key: "5",
      label: "ABOUT US",
      categories: [],
      link:"about-us"
    },
    { key: "6", label: "CONTACT US", categories: [], link:"contact-us" },
  ];

  const activeMenu = ref<any>(null);

  let hideMenuTimeout: any = null;
  let menu = ref<any>(false);

  let hamMenu = ref<any>(false);
  let hamSubMenu = ref<any>(false);

  const showMenu = (item: any) => {
    clearHideMenuTimeout();
    activeMenu.value = item;
    menu.value = true;
  };

  const scheduleHideMenu = () => {
    hideMenuTimeout = setTimeout(() => {
      activeMenu.value = null;
      menu.value = false;
    }, 1000);
  };

  const clearHideMenuTimeout = () => {
    if (hideMenuTimeout) {
      clearTimeout(hideMenuTimeout);
      hideMenuTimeout = null;
    }
  };

  function hambergerMenu(){
    hamMenu.value = true;
    activeMenu.value = null;
  }

  function hamMenuItemClick(item: any){
    activeMenu.value = item;
    hamSubMenu.value = !hamSubMenu.value;
  }

  function subMenuBack(){
    hamSubMenu.value = !hamSubMenu.value;
    hamMenu.value = true;
    activeMenu.value = null;
  }

  function menuClick(item: any){
    if(item.categories.length === 0 && item.link){
      router.push({ name: item.link })
      window.scrollTo(0, 0);
    }
  }
  
  function routeToLink(link: any){
    router.push({ name: link })
    window.scrollTo(0, 0);
  }

  const windowWidth = ref(window.innerWidth);

  const handleResize = () => {
    windowWidth.value = window.innerWidth;
  };

  const isMobile = ref(false);

  const checkIfMobile = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/android/i.test(userAgent)) {
      isMobile.value = true;
      return;
    }

    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      isMobile.value = true;
      return;
    }

    if (/Windows Phone/i.test(userAgent)) {
      isMobile.value = true;
      return;
    }

    if (/BB10|BlackBerry/i.test(userAgent)) {
      isMobile.value = true;
      return;
    }

    if (/webOS|Palm/i.test(userAgent)) {
      isMobile.value = true;
      return;
    }

    isMobile.value = false;
  };

  onMounted(() => {
    window.addEventListener('resize', handleResize);
    checkIfMobile();
    screenType(props.screenName);
  });

  onUnmounted(() => {
    window.removeEventListener('resize', handleResize);
  });

  watch(windowWidth, (newWidth, oldWidth) => {
    if (newWidth > 990 && oldWidth <= 990 && hamSubMenu.value === true) {
      subMenuBack();
    }
  });

  const screenType = (screenName: string) => {
    // alert(isMobile.value ? "Mobile" : "Desktop")
    const oldStyle = document.getElementById('dynamic-media-queries');
    if(oldStyle){
      oldStyle.remove();
    }

    let maxWidth = isMobile.value ? '1179' : '990';
    let minWidth = isMobile.value ? '1180' : '991';
    if(screenName === 'complySync'){
      maxWidth = isMobile.value ? '1179' : '1230';
      minWidth = isMobile.value ? '1180' : '1231';
    }

    let mediaQuery = `
      @media (max-width: ${maxWidth}px) {
        .mymenu >>> .v-overlay__content {
          width: 700px !important;
          margin-left: calc(100% - 732px) !important;
        }
        .menu-section-hamburger {
          display: block !important;
        }
        .menu-section {
          display: none !important;
        }
        .ham-menu-style {
          display: block !important;
        }
        .ham-submenu-style {
          display: block !important;
        }
        .mymenu {
          visibility: hidden !important;
        }
      }
      @media (min-width: ${minWidth}px) {
        .menu-section-hamburger {
          display: none !important;
        }
        .menu-section {
          display: block !important;
        }
        .ham-menu-style {
          display: none !important;
        }
        .ham-submenu-style {
          display: none !important;
        }
      }
    `;

    const styleTag = document.createElement('style');
    styleTag.id = 'dynamic-media-queries';
    styleTag.textContent = mediaQuery;
    document.head.appendChild(styleTag);
  };
</script>

<style scoped>
  .logo-image {
    /* height: 38px; */
    height: 100%;
    margin-left: 13px;
    cursor: pointer;
    /* width: 113.4px; */
  }
  .sub-logo-image {
    height: 57%;
    margin-left: 13px;
    margin-bottom: 4px;
    cursor: pointer;
  }
  .app-bar-style {
    background-color: #fff;
    /* background-color: transparent; */
  }
  .app-bar-style>>>.v-toolbar__prepend
  {
    max-width: 345px !important;
  }
  .menu-items {
    letter-spacing: 0.1px;
    font-size: 15px;
    /* font-size: 16px; */
    line-height: 20px;
    font-weight: 700;
    color: #000;
    /* text-shadow: 1px 3px 5px rgba(0, 0, 0, 0.4); */
    cursor: pointer;
    margin-top: 5px;
    border-bottom: 3px solid transparent;
    transition: color 0.5s ease, border-bottom 0.5s ease;
  }
  .menu-item-hover{
    color: #0C62B7;
    border-bottom: 3px solid #0C62B7;
  }
  .logo {
    height: 38px;
    float: left;
    margin-left: -28px;
  }
  .card-style{
    background-color: #f2f2f2 !important;
  }
  .card-style .v-card-actions{
    padding: 0;
  }
  .card-style-action{
    display: block;
  }
  .card-menu-item{
    padding: 8px;
    padding-left: 12px;
    padding-right: 12px;
    cursor: pointer;
  }
  .card-menu-item:hover{
    background-color: #0C62B7;
  }
  .card-menu-item:hover .drop-down-links{
    color: #fff
  }
  .drop-down-links {
    text-decoration: none;
    color: #000;
    font-size: 17px;
    font-weight: 500;
    max-width: 30px !important;
    cursor: pointer;
  }
  .mymenu >>> .v-overlay__content{
    /* margin-left: calc(100% - 830px); */
    /* width: 800px; */
    min-width: 200px;
    margin-top: 64px;
    position: fixed;
    border-radius: 0px;
    border: 1px solid #888888;
  }
  .capability-menu >>> .v-overlay__content{
    margin-left: calc(100% - 830px);
  }
  .solutions-menu >>> .v-overlay__content{
    margin-left: calc(100% - 685px);
  }
  .sectors-menu >>> .v-overlay__content{
    margin-left: calc(100% - 555px);
  }
  .menu-section-hamburger{
    display: none;
  }
  .menu-section{
    display: block;
  }
  @media (max-width: 950px) {
    .mymenu >>> .v-overlay__content{
      width: 750px;
      margin-left: calc(100% - 782px);
    }
  }
  .menu-title{
    color: #939598;
    font-size: 26px;
    font-weight: 900;
    margin-left: 8px;
  }
  .ham-menu-style >>> .v-overlay__content{
    position: fixed;
    right: 0;
    margin-top: 64px;
    border-radius: 0px;
    width: 315px;
  }
  .ham-menu-card-style{
    padding: 30px;
    background-color: #1B1B1B !important;
  }
  .ham-menu-links {
    text-decoration: none;
    color: #ffffff;
    font-size: 16px;
    font-weight: 300;
  }
  .ham-menu-items{
    border-bottom: 1px solid #2e2e2e;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
  }
  .ham-submenu-style >>> .v-overlay__content{
    position: fixed;
    right: 0;
    margin-top: 64px;
    border-radius: 0px;
    width: 285px;
    min-height: 345px;
  }
  .ham-submenu-card-style{
    padding: 30px;
    background-color: #282828 !important;
    /* align-items: center;
    display: flex; */
  }
  .ham-submenu-card-style >>> .v-card-actions{
    width: 220px;
  }
  .ham-submenu-links {
    text-decoration: none;
    color: #ffffff;
    font-size: 16px;
    font-weight: 300;
    cursor: pointer;
  }
  .ham-submenu-items{
    border-bottom: 1px solid #555555;
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 42px !important;
  }
  .back-icon{
    background-image: url(../assets/header/back.png);
    background-repeat: no-repeat;
    height: 29px;
    text-align: center;
    width: 66px;
    margin-bottom: 16px !important;
    margin-top: 0;
    margin-left: 0;
    display: block;
    cursor: pointer;
  }
</style>